import Ukiyo from "ukiyojs";

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import smoothScroll from "smooth-scroll";
import { MatchHeight } from "js-match-height";

const matchHeight = new MatchHeight(".matchHeight");

/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
gsap
イージングはhttps://greensock.com/docs/v3/Easing
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー**/
gsap.config({
 nullTargetWarn: false,
});

//インビューエフェクト
gsap.set(".inview_fadeInUp", {
 y: 100,
 opacity: 0,
});
gsap.set(".inview_fadeIn", {
 opacity: 0,
});

ScrollTrigger.batch(".inview_fadeInUp", {
 onEnter: (batch) =>
  gsap.to(batch, {
   ease: "back",
   opacity: 1,
   y: 0,
   stagger: 0.05,
   overwrite: true,
  }),
 onEnterBack: (batch) =>
  gsap.to(batch, {
   ease: "back",
   opacity: 1,
   y: 0,
   stagger: 0.05,
   overwrite: true,
  }),
 once: true,
});
ScrollTrigger.addEventListener("refreshInit", () =>
 gsap.set(".inview_fadeInUp", {
  y: 0,
 })
);

ScrollTrigger.batch(".inview_fadeIn", {
 onEnter: (batch) =>
  gsap.to(batch, {
   ease: "power1",
   opacity: 1,

   stagger: 0.05,
   overwrite: true,
  }),
 onEnterBack: (batch) =>
  gsap.to(batch, {
   ease: "power1",
   opacity: 1,
   stagger: 0.05,
   overwrite: true,
  }),
 once: true,
});
ScrollTrigger.addEventListener("refreshInit", () =>
 gsap.set(".inview_fadeIn", {
  opacity: 0,
 })
);

const inview_events = document.querySelectorAll(".inview_event");
inview_events.forEach((inview_event, i) => {
 gsap.to(inview_event, {
  scrollTrigger: {
   trigger: inview_event,
   start: "center bottom", //要素の基準値とブラウザの画面値
   end: "bottom top",
  },
 }),
  ScrollTrigger.create({
   trigger: inview_event,
   start: "center bottom", //要素の基準値とブラウザの画面値
   end: "bottom top",
   id: inview_event + 1,
   once: true,
   toggleClass: {
    targets: inview_event,
    className: "event-on",
   },
  });
});

/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
imageUkyo
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー**/
const imageUkyo = document.querySelector(".imgparallax");
new Ukiyo(imageUkyo, {
 scale: 1.2, //スケール
 speed: 1.3, //スピード
 // willChange: true, //will-change付ける
 wrapperClass: "wrapper", //ラッパー要素のクラス名
});

/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
*スマホメニューボタン
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー**/

document.addEventListener("DOMContentLoaded", function () {
 let menuBtn = document.querySelector(".menuBtn");
 let body = document.body;
 document.addEventListener("click", (e) => {
  if (e.target.closest(".menuBtn")) {
   body.classList.contains("menu-open") ? body.classList.remove("menu-open") : body.classList.add("menu-open");
  } else {
   body.classList.remove("menu-open");
  }
 });
});

/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
* back_to_top
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー**/
const pagetop = document.querySelector(".backtotop");
const yws_pagetop = function () {
 if (window.pageYOffset > 400) {
  pagetop.classList.add("backtotop-visible");
 } else {
  pagetop.classList.remove("backtotop-visible");
 }
};
window.addEventListener("load", yws_pagetop);
window.addEventListener("scroll", yws_pagetop);
pagetop.addEventListener("click", (e) => {
 e.preventDefault();
 window.scroll({
  top: 0,
  behavior: "smooth",
 });
});

/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
* smooth-scroll function
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー**/
let smoothScrollOptions = {
 speed: 300, //1000px進むスピード
 easing: "easeInOutCubic", //イージング

 updateURL: false,
 header: "[data-scroll-header]",
};

let scroll = new smoothScroll('a[href*="#"]', smoothScrollOptions);

//別ページから遷移して来た場合
window.addEventListener("DOMContentLoaded", function () {
 const headerHeight = document.getElementById("header").clientHeight;
 const urlHash = location.hash;
 if (urlHash) {
  setTimeout(function () {
   window.scrollTo({ top: 0 }, 0);
  });
  setTimeout(function () {
   //ペー,ジロード用に処理を遅らす
   // スクロール先の要素を取得 （アンカーの リンク先 #.. の # を取り除いた名前と一致する id名の要素）
   const urlTarget = document.getElementById(urlHash.replace("#", ""));

   // スクロール先の要素の位置を取得
   const urlPosition = window.pageYOffset + urlTarget.getBoundingClientRect().top - headerHeight - 30;

   // スクロールアニメーション
   window.scroll({
    top: urlPosition, // スクロール先要素の左上までスクロール
    behavior: "smooth", // スクロールアニメーション
   });
  }, 100);
 }
});

/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
スマホのみTEL有効
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー**/

var agent = navigator.userAgent;
if (agent.search(/iPhone/) != -1 || agent.search(/iPad/) != -1 || agent.search(/iPod/) != -1 || agent.search(/Android/) != -1) {
 window.addEventListener("DOMContentLoaded", function () {
  if (!isPhone()) return;
  const actionTarget = document.querySelectorAll("span[data-action=call]");
  for (let i = 0; i < actionTarget.length; i++) {
   actionTarget[i].outerHTML = '<a href="tel:' + actionTarget[i].dataset.tel + '">' + actionTarget[i].outerHTML + "</a>";
  }
 });
 function isPhone() {
  return navigator.userAgent.indexOf("iPhone") > 0 || navigator.userAgent.indexOf("Android") > 0;
 }
}

/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
メンバーポップアップ
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー**/

// アコーディオン
document.addEventListener("DOMContentLoaded", function () {
 const mb_popup = document.querySelectorAll(".member-popup");

 for (let i = 0; i < mb_popup.length; i++) {
  mb_popup[i].addEventListener("click", function () {
   for (let j = 0; j < mb_popup.length; j++) {
    if (mb_popup[i] !== mb_popup[j]) {
     mb_popup[j].classList.remove("tip-open");
     let tooltip = mb_popup[j].querySelector(".member-popup-tooltipArea");
     tooltip.style.left = 0 + "px";
     //mb_popup[j].nextElementSibling.classList.remove('open');
    }
   }

   let rightSpace = "";
   let tooltip = this.querySelector(".member-popup-tooltipArea");
   tooltip.style.left = 0 + "px";
   let objRightPosition = tooltip.getBoundingClientRect().right;
   let docWidth = document.body.clientWidth;
   if (objRightPosition > docWidth) {
    tooltip.style.left = docWidth - objRightPosition - 20 + "px";
   }

   this.classList.toggle("tip-open");
   //this.nextElementSibling.classList.toggle('open');
  });
 }
});
